import { MonthYearBox } from '@apply/components';
import { usePaymentStore } from '../../../../../state/paymentStore';
import { CardFocusType } from '../../../constants/CardFocusType';

interface CardMonthYearParameters {
    disabled: boolean;
}

export const CardMonthYear: React.FC<CardMonthYearParameters> = ({ disabled }) => {
    const cardMonthYear = usePaymentStore((s) => s.cardMonthYear);
    const set_cardMonthYear = usePaymentStore((s) => s.set_cardMonthYear);
    const set_cardFocus = usePaymentStore((s) => s.set_cardFocus);

    return (
        <MonthYearBox
            name='expiry'
            label='Expiration'
            value={cardMonthYear}
            onChangeWithMask={(value) => set_cardMonthYear(value)}
            onFocusIn={() => set_cardFocus(CardFocusType.Expiration)}
            disabled={disabled}
        />
    );
};
